import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h2>Sayfa Bulunamadı</h2>
    </div>
  );
};

export default NotFound;
